import { call, put } from 'redux-saga/effects'
import { apiConfig } from '../../../../../config/api-config'
import { makeAccess } from '../../../../../config/factory-controller'
import { LoginRepository } from '../../../data/repositories/login-repository'
import type { LoginRequest, User } from '../../../domain/models/user'
import { LoginService } from '../../../service/login-service'
import { LoginController } from '../../controllers/login-controller'
import * as action from '../actions/login-actions'
import * as journeyAction from '../../../../journey/presentation/redux/actions/journey-actions'

export const controller = async (payload: LoginRequest) => {
  const { key, token } = await makeAccess()
  const dataSource = new LoginService(apiConfig(key, token))
  const repository = new LoginRepository(dataSource)
  const control = new LoginController(repository)
  const result = await control.login(payload)
  
  return result
}

export function* loginSaga({ payload }: any): any {
  try {
    const result: User = yield call(controller, payload)
    yield put(action.loginSuccess(result))
    
    // After successful login, check if user has an existing journey
    yield put(journeyAction.getJourneyRequest({ userId: result.userId }))
  } catch (error: any) {
    yield put(action.loginError(error.toString()))
  }
}
